import { Component, Host, h, Prop, Watch } from '@stencil/core';

@Component({
  tag: 'sy-progress-bar',
  styleUrls: ['scss/index.scss', 'sccs/_tokens.scss'],
  shadow: true,
})
export class ProgressBar {
  /**
   * Percentage of the bar that must be active. Must be a value between 0 and 100. Only applied if the 'type' is 'determinate'
   */
  @Prop({ mutable: true }) value: number;

  /**
   * If true, the direction of the progress bar will be reversed
   */
  @Prop({ reflect: true }) reverse = false;

  /**
   * State of the progress bar: 'determinate' means that the percentage of completion is known and the bar size will be defined by 'value', 'indeterminate' means that the percentage is unknown and the bar will play a looping animation.
   */
  @Prop({ reflect: true }) type: 'determinate' | 'indeterminate' = 'determinate';

  /**
   * Adjusts invalid values and sets a fixed value if type is indeterminate
   */
  @Watch('value')
  @Watch('type')
  validateValueWatcher(): void {
    this.fixValue();
  }

  componentWillLoad() {
    this.fixValue();
  }

  private fixValue() {
    if (this.value < 0) {
      this.value = 0;
    } else if (this.value > 100) {
      this.value = 100;
    }

    this.value = this.type === 'indeterminate' ? 100 : this.value;
  }

  private getProgressBarAttributes() {
    const attributes = {
      class: 'sy-progress-inner-bar',
      role: 'progressbar',
      style: { width: `${this.value}%` },
      ariaValueNow: this.value,
      ariaValueMin: '0',
      ariaValueMax: '100',
    };
    return attributes;
  }

  render() {
    return (
      <Host>
        <div {...this.getProgressBarAttributes()}></div>
      </Host>
    );
  }
}
